/**
 * Landing Page Constants
 * Static data for landing page sections
 */

import { Eye, Image, Megaphone, Gift, Tv, Package } from "lucide-react";

export const FEATURES = [
  {
    title: "Virtual Try-On Studio",
    description:
      "Let customers see your products on themselves with AI-powered virtual try-on technology.",
    icon: Eye,
  },
  {
    title: "Product Staging Pro",
    description:
      "Place your products in stunning, realistic environments without expensive photo shoots.",
    icon: Image,
  },
  {
    title: "AI Ad Creative Generator",
    description:
      "Generate high-converting ad creatives in seconds with AI-powered design intelligence.",
    icon: Megaphone,
  },
  {
    title: "Personalized Gift Designer",
    description:
      "Create unique, personalized gift visualizations that drive customer engagement.",
    icon: Gift,
  },
  {
    title: "AR Furniture Visualizer",
    description:
      "Show customers exactly how furniture will look in their space with augmented reality.",
    icon: Tv,
  },
  {
    title: "AI Unboxing Video Creator",
    description:
      "Generate engaging unboxing videos automatically to showcase your products.",
    icon: Package,
  },
];

export const TESTIMONIALS = [
  {
    name: "Sarah Chen",
    role: "Marketing Director, LuxeFashion",
    content:
      "MerchMidas transformed our product photography workflow. We're saving $50K monthly on photoshoots while increasing conversions by 40%.",
    rating: 5,
  },
  {
    name: "Michael Rodriguez",
    role: "CEO, HomeStyle Furniture",
    content:
      "The AR visualizer reduced our return rate by 60%. Customers know exactly what they're getting before they buy.",
    rating: 5,
  },
  {
    name: "Emma Thompson",
    role: "E-commerce Manager, BeautyBrand",
    content:
      "Virtual try-on increased our add-to-cart rate by 85%. This tool pays for itself within the first week.",
    rating: 5,
  },
];

export const CASE_STUDIES = [
  {
    company: "TechGear Pro",
    industry: "Electronics",
    result: "300% ROI in 3 months",
    description:
      "Increased online sales by implementing virtual product staging across 5,000+ SKUs.",
    metric: "+127%",
    metricLabel: "Conversion Rate",
  },
  {
    company: "Artisan Jewelry Co",
    industry: "Fashion & Accessories",
    result: "60% faster time-to-market",
    description:
      "Launched 12 collections with AI-generated marketing materials instead of traditional photoshoots.",
    metric: "$180K",
    metricLabel: "Cost Saved",
  },
  {
    company: "Modern Living",
    industry: "Home & Furniture",
    result: "40% reduction in returns",
    description:
      "AR visualization helped customers make confident purchase decisions for furniture items.",
    metric: "1.2M",
    metricLabel: "Products Visualized",
  },
];
